import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {

	function scrollToRef(id) {
		var elmnt = document.getElementById(id);
		elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

    return (
    	<React.Fragment>
	        <div className="loader">
	    		<div className="spinner">
				  <div className="double-bounce1"></div>
				  <div className="double-bounce2"></div>
				</div>
	    	</div>				
			<div className="nav-container">
				<nav className="simple-bar top-bar">
					<div className="container">
						<div className="row nav-menu">
							<div className="col-md-3 col-sm-3 columns">
								<NavLink to="/">
									<img className="logo logo-dark" alt="Logo" src="img/logo.png" />
								</NavLink>
							</div>
						
							<div className="col-md-9 col-sm-9 columns text-right">
								<ul className="menu">
									{/* <li>
										<NavLink to="/" exact activeClassName="active">Home</NavLink>
									</li>
									<li>
										<NavLink to="/about">About me</NavLink>
									</li>
									<li>
										<NavLink to="/portfolio">portfolio</NavLink>
									</li>
									<li>
										<NavLink to="/blog">Blog</NavLink>
									</li> 
									<li>
										<NavLink to="/contact">Contact</NavLink>
									</li>
									*/}
									<li>
										<NavLink to="" onClick={()=>scrollToRef('home')} activeClassName="active1">Home</NavLink>
									</li>
									<li>
										<NavLink to="" onClick={()=>scrollToRef('about')} activeClassName="active1">About me</NavLink>
									</li>
									<li>
										<NavLink to="" onClick={()=>scrollToRef('portfolio')} activeClassName="active1">portfolio</NavLink>
									</li>
									<li>
										<NavLink to="" onClick={()=>scrollToRef('contact')} activeClassName="active1">Contact</NavLink>
									</li>
								</ul>
							</div>
						</div>					
						<div className="mobile-toggle">
							<i className="icon icon_menu"></i>
						</div>					
					</div>
				</nav>
			</div>
		</React.Fragment>
    )
}

export default Header;